import script from "./chaxun.vue?vue&type=script&setup=true&lang=js"
export * from "./chaxun.vue?vue&type=script&setup=true&lang=js"

import "./chaxun.vue?vue&type=style&index=0&id=2dd872c0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd872c0"]])

export default __exports__